/* eslint-disable no-underscore-dangle */

export interface AWSResponse {
  data: any;
  status: number;
  statusText: string;
  headers: { [key: string]: string };
}

export function isAWSResponse(obj: any): obj is AWSResponse {
  if (!obj
    || !obj.status
    || !obj.headers
    || !obj.data) {
    return false;
  }
  return typeof obj.status === 'number'
    && typeof obj.headers === 'object'
    && typeof obj.data === 'object';
}

export interface AWSError {
  code?: string;
  name?: string;
  response?: AWSResponse;
  message: string;
}

export function isAWSError(obj: any): obj is AWSError {
  if (obj.response) {
    return typeof obj.message === 'string' && isAWSResponse(obj.response);
  }
  return typeof obj.message === 'string'
    && typeof obj.code === 'string'
    && typeof obj.name === 'string';
}

// This function will attempt to remove a cookie from all paths.
// Source: https://stackoverflow.com/a/33366171
export function eraseCookieFromAllPaths(cookieDomain: string, name = 'CognitoIdentityServiceProvider') {
  const cookies = document.cookie.split('; ');
  if (cookies.length < 1) {
    return;
  }

  const cognitoCookies = cookies.reduce<string[]>((result, cookie: string) => {
    if (cookie.startsWith(name)) {
      const index = cookie.indexOf('=');
      if (index >= 0) {
        result.push(cookie.substring(0, index + 1));
      }
    }
    return result;
  }, []);

  const expires = 'expires=Thu, 01-Jan-1970 00:00:01 GMT';
  const domain = `domain=${cookieDomain}`;
  const path = 'path=/'; // login app only has cookie on this path
  cognitoCookies.forEach((cookie) => {
    document.cookie = [cookie, expires, domain, path].join('; ');
  });
}
